export default __webpack_public_path__ + "static/media/trabajando.b063b104.png";